module.exports = __webpack_public_path__ + "flags-31719cd1.webp";